"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastCartCleanedByCycle = exports.CART_CLEANED_BY_CYCLE_MESSAGE = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.CART_CLEANED_BY_CYCLE_MESSAGE = 'As promoções da loja foram atualizadas. Coloque os produtos no carrinho novamente.';
const toastCartCleanedByCycle = () => {
    flora_react_1.Toaster.notify({
        description: exports.CART_CLEANED_BY_CYCLE_MESSAGE,
        origin: 'center-top',
        kind: 'alert',
        timer: 10000,
    });
};
exports.toastCartCleanedByCycle = toastCartCleanedByCycle;
